<template>
    <simple-dropdown position="left">
        <template #trigger>
            <button
                class="flex gap-4 rounded-32 bg-primary-20 hover:bg-primary text-black hover:text-white text-body-sm py-4 px-8"
            >
                <span class="uppercase">{{ activeItem }}</span>
                <svg-icon class="w-18 h-18" type="keyboard-arrow-down"></svg-icon>
            </button>
        </template>
        <template #content="{ close }">
            <button v-for="locale in items"
                    class="flex gap-4 items-center hover:bg-primary px-16 py-8 w-full text-primary-80 hover:text-white text-left transition-colors"
                    @click="$emit('input', locale.value); close();"
            >
                <span class="uppercase">{{ locale.value }}</span>
                -
                <span class="first-letter:uppercase">{{ locale.label }}</span>
            </button>
        </template>
    </simple-dropdown>
</template>

<script>
import SimpleDropdown from './SimpleDropdown.vue';
import SvgIcon from './SvgIcon.vue';

export default {
    components: {SvgIcon, SimpleDropdown},
    props: {
        items: null,
        activeItem: '',
        overrideButtonClass: String,
    },
    computed: {
        buttonClass(){
            if (this.overrideButtonClass) {
                return this.overrideButtonClass;
            }

            return 'border border-primary-5 hover:bg-primary-5 font-semibold py-12 px-14 flex items-center justify-center text-primary rounded leading-none trans-ease';
        }
    }
};
</script>